<template>
  <span>
    <h3 id="titulo" class="text-center">Relatório de Reserva Cartão</h3>
    <div>
      <table id="tabela">
        <thead>
          <tr>
            <th class="col_consignataria">Consignatária</th>
            <th>Matrícula</th>
            <th>CPF</th>
            <th>Servidor</th>
            <th>Situação</th>
            <th>Rubrica</th>
            <th>Entidade</th>
            <th>Data do Cadastro</th>
            <th>Data de Cancelamento</th>
            <th>Data da Operação</th>
            <th>Status Reserva</th>
            <th class="text-right">Valor da Reserva</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(data, index) in relatorioStore.response"
            :key="data.id + '-' + index">
            <td>{{ truncateText(data.consignatariaRazaoSocial, 30) }}</td>
            <td>{{ data.matricula }}</td>
            <td>{{ data.cpf | mascaraCpf }}</td>
            <td>{{ truncateText(data.servidor, 30) }}</td>
            <td>{{ data.statusServidor }}</td>
            <td>{{ data.rubrica }}</td>
            <td>{{ data.nomeEntidade }}</td>
            <td>{{ data.dataCadastro | formatarData }}</td>
            <td>{{ data.dataCancelamento | formatarData }}</td>
            <td>{{ data.dataOperacao | formatarData }}</td>
            <td>{{ data.statusReservaCartao.descricao }}</td>
            <td class="text-right">
              <span v-if="relatorioStore.contentType == 'PDF'">
                {{ data.valorReserva | formatarValor }}
              </span>
              <span v-else>
                {{ data.valorReserva | formatarValorSemCifrao }}
              </span>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="10" class="text-right">Total</td>
            <td colspan="1" class="formatarValor">
              {{ totalValorReserva() | formatarValor }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </span>
</template>
<script>
import { storeRelatorio } from '@/stores/relatorio'

export default {
  setup() {
    const relatorioStore = storeRelatorio()

    return { relatorioStore }
  },

  mounted() {
    if ('EXCEL' === this.relatorioStore.contentType) {
      this.$emit('gerarExcel')
    } else {
      this.$emit('gerarPDF')
    }
  },

  methods: {
    totalValorReserva() {
      let total = 0
      this.relatorioStore.response.map((item) => {
        total += item.valorReserva
      })
      return this.formatarValor(total)
    },

    formatarValor(value) {
      return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    },
    truncateText(text, length) {
      if (text.length > length) {
        return text.substring(0, length) + '...'
      } else {
        return text
      }
    },
  },
}
</script>
<style lang="scss" scoped>
#titulo {
  font-weight: bold;
}

.formatarValor {
  text-align: right !important;
}

.col_consignataria {
  width: 60px;
}

#tabela {
  border-collapse: collapse;
  width: 100%;
  font-size: 0.675rem;
}
#tabela th {
  background-color: #333;
  color: #fff;
  padding: 4%;
  text-align: center;
}

#tabela td {
  text-align: center;
  padding: 4%;
  border-bottom: 1px solid #ddd;
}

#tabela tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

#tabela tfoot {
  background-color: #666666;
  color: #fff;
}

@media print {
  #titulo {
    font-weight: bold;
  }

  .formatarValor {
    text-align: right !important;
  }

  #tabela {
    border-collapse: collapse;
    width: 100%;
    font-size: 0.675rem;
  }
  #tabela th {
    background-color: #333;
    color: #fff;
    padding: 10px;
    text-align: left;
  }

  #tabela td {
    padding: 10px;
    border-bottom: 1px solid #ddd;
  }

  #tabela tbody tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  #tabela tfoot {
    background-color: #666666;
    color: #fff;
  }
}
</style>
